import { render, staticRenderFns } from "./supply-details.vue?vue&type=template&id=59696363&scoped=true&"
import script from "./supply-details.vue?vue&type=script&lang=js&"
export * from "./supply-details.vue?vue&type=script&lang=js&"
import style0 from "./supply-details.vue?vue&type=style&index=0&id=59696363&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59696363",
  null
  
)

export default component.exports